import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { ABOUT_IMAGES } from "../../data/site";
import { Frangipani, TornEdge } from "../Ornaments";

export function AboutGurudev() {
  return (
    <section className="about" aria-labelledby="about-title">
      <TornEdge
        edge="top"
        color="var(--brown-800)"
        seed={3}
        className="about-edge about-edge--top"
      />
      <div className="about-inner container">
        <div className="about-collage">
          <figure className="polaroid polaroid--main">
            <img
              src={ABOUT_IMAGES.main.src}
              alt={ABOUT_IMAGES.main.alt}
              loading="lazy"
              width={900}
              height={585}
            />
          </figure>
          <figure className="polaroid polaroid--top">
            <img
              src={ABOUT_IMAGES.top.src}
              alt={ABOUT_IMAGES.top.alt}
              loading="lazy"
              width={700}
              height={489}
            />
          </figure>
          <figure className="polaroid polaroid--bottom">
            <img
              src={ABOUT_IMAGES.bottom.src}
              alt={ABOUT_IMAGES.bottom.alt}
              loading="lazy"
              width={700}
              height={476}
            />
          </figure>
          <Frangipani className="about-flower" />
        </div>

        <div className="about-copy">
          <h2 id="about-title" className="about-title">
            <span className="block">About Gurudev</span>
            <span className="block">Muni Jambuvijayaji Maharaj Saheb</span>
          </h2>
          <p>
            Muni Jambuvijayaji Maharaj Saheb (1923–2009) was a revered Jain
            scholar, spiritual guide, and a dedicated researcher who preserved
            and enriched the vast heritage of Jain knowledge.
          </p>
          <Link to="/about/gurudev" className="btn btn-parchment">
            Read Biography
            <ArrowRight aria-hidden="true" />
          </Link>
        </div>
        {/* palm-leaf manuscript from the approved section artwork */}
        <figure className="about-art" aria-hidden="true">
          <img
            src="/images/home/insight-manuscript.webp"
            alt=""
            loading="lazy"
          />
        </figure>
      </div>
      <TornEdge
        edge="bottom"
        color="var(--brown-800)"
        seed={19}
        className="about-edge about-edge--bottom"
      />
    </section>
  );
}
